import { Modal } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { CustomInput, ReactSelect } from "../kits/Inputs/Inputs";
import useAxios from "../../services/useAxios";
import { debounce } from "lodash";
import "./inventory-list-page-style.scss";
import CustomButton from "../kits/button/CustomButton";
import { useEffect, useState } from "react";

export default function AddBillModal({
  show,
  setShow,
  proDebounce,
  orderDebounce,
  productItem,
  userDebounce,
  configItem,
  showCategory,
  formValues,
  handelChangeSelect,
  handelChangeInput,
  productHandeler,
  handleChangeProperties,
  handleChangePropertiesّInput,
  userItem,
  orders,
  handelChangeDate,
  addRecordApiHandler,
  clearFormValues,
  showValid,
}) {
  // state for maping properties
  const [selectedOptions, setSelectedOptions] = useState({});
  console.log("selectedOptions", selectedOptions);
  console.log("selectedOptions formValues", formValues);
  return (
    <Modal
      show={show}
      onHide={() => {
        setShow();
        clearFormValues();
      }}
      contentClassName="add-bill-modal"
    >
      <Modal.Header closeButton>افزودن قبض ورودی</Modal.Header>
      <Modal.Body className="d-flex flex-wrap">
        <div className="mt-2 px-1 col-6">
          <ReactSelect
            title="انتخاب انبار"
            itemsList={configItem.dataRepository}
            inputValue={formValues.repository}
            onChangeFunc={(e) => {
              handelChangeSelect(e, "repository");
            }}
            textErr={
              showValid && !formValues.repository ? "این فیلد باید پر باشد" : ""
            }
            placeholder="..."
            inputSize="same-as-select"
          ></ReactSelect>
        </div>
        <div className="mt-2 px-1 col-6 ">
          <ReactSelect
            title="انتخاب محصول"
            itemsList={productItem.dataPro.selectItem}
            inputValue={formValues.product}
            onInputChangeFunc={(e) => {
              proDebounce(e);
            }}
            onChangeFunc={(e) =>
              productHandeler(
                e,
                "data",
                productItem.dataPro.propertiesItem,
                handelChangeSelect,
                "product"
              )
            }
            textErr={
              showValid && !formValues.product ? "این فیلد باید پر باشد" : ""
            }
            inputSize="same-as-select"
          ></ReactSelect>
        </div>
        {showCategory.data.length > 0 && (
          <div className="w-100 d-flex flex-wrap border rounded shadow py-2 px-1">
            <span className="w-100" style={{ fontSize: 12 }}>
              صفات محصول
            </span>
            {showCategory?.data?.map((data) => {
              if (data.type == 1) {
                return (
                  <div className="px-1 mt-2 col-6">
                    <CustomInput
                      key={data.property_id}
                      label={data.title}
                      inputSize="same-as-select"
                      type="text"
                      inputContainer=""
                      inputValue={selectedOptions[data.property_id]}
                      onChangeFunc={(e) => {
                        if (!isNaN(e.target.value)) {
                          handleChangePropertiesّInput(
                            data.property_id,
                            e.target.value,
                            setSelectedOptions
                          );
                        }
                      }}
                    />
                  </div>
                );
              } else if (data.type == 2) {
                const options = data.options.split(",").map((option) => ({
                  value: option,
                  label: option,
                }));

                return (
                  <div className="px-1 mt-2 col-6">
                    <ReactSelect
                      key={data.property_id}
                      title={data.title}
                      itemsList={options}
                      inputValue={selectedOptions[data.property_id]}
                      onChangeFunc={(selectedOption) =>
                        handleChangeProperties(
                          data.property_id,
                          selectedOption,
                          setSelectedOptions
                        )
                      }
                      placeholder="..."
                      inputSize="same-as-select"
                    ></ReactSelect>
                  </div>
                );
              }
            })}
          </div>
        )}

        <div className="col-sm-3 col-12 mt-2 px-1">
          <CustomInput
            id="titleTour"
            label="تعداد "
            inputSize="same-as-select"
            type="text"
            activate="disabled"
            inputContainer=""
            inputValue={""}
            textErr={""}
            onChangeFunc={(e) => {}}
          />
        </div>

        <div className="col-sm-3 col-12 mt-2 px-1">
          <label className="form-label-custom" style={{ marginBottom: 8 }}>
            زمان ورود
          </label>
          <DatePicker
            containerClassName={
              showValid && !formValues.loginTime ? "date-input-err" : ""
            }
            value={""}
            calendar={persian}
            locale={persian_fa}
            calendarPosition="bottom-right"
            onChange={(e) => {
              handelChangeDate(e, "loginTime");
            }}
          />
          {showValid && !formValues.loginTime && (
            <div className="date-input-validate">این فیلد باید پر باشد</div>
          )}
        </div>
        {/* <div className="col-6 mt-2 px-1">
          <label className="form-label-custom" style={{ marginBottom: 8 }}>
            زمان ثبت
          </label>
          <DatePicker
            value={""}
            calendar={persian}
            locale={persian_fa}
            calendarPosition="bottom-right"
            onChange={(e) => { }}
          />
        </div> */}
        <div className="mt-2 px-1 col-12 col-sm-6">
          <ReactSelect
            title="جایگاه"
            itemsList={configItem.dataPosition}
            inputValue={formValues.position}
            onChangeFunc={(e) => {
              handelChangeSelect(e, "position");
            }}
            textErr={
              showValid && !formValues.position ? "این فیلد باید پر باشد" : ""
            }
            placeholder="..."
            inputSize="same-as-select"
          ></ReactSelect>
        </div>
        <div className="mt-2 px-1 col-12 col-sm-6">
          <ReactSelect
            title="کاربر تحویل گیرنده"
            itemsList={userItem.dataUser}
            inputValue={formValues.userReceive}
            onChangeFunc={(e) => {
              handelChangeSelect(e, "userReceive");
            }}
            onInputChangeFunc={(e) => {
              userDebounce(e);
            }}
            textErr={
              showValid && !formValues.userReceive
                ? "این فیلد باید پر باشد"
                : ""
            }
            placeholder="..."
            inputSize="same-as-select"
          ></ReactSelect>
        </div>
        <div className="mt-2 px-1 col-12 col-sm-6">
          <ReactSelect
            title="کاربر تحویل دهنده"
            itemsList={userItem.dataUser}
            inputValue={formValues.userSend}
            onChangeFunc={(e) => {
              handelChangeSelect(e, "userSend");
            }}
            onInputChangeFunc={(e) => {
              userDebounce(e);
            }}
            textErr={
              showValid && !formValues.userSend ? "این فیلد باید پر باشد" : ""
            }
            placeholder="..."
            inputSize="same-as-select"
          ></ReactSelect>
        </div>
        <div className="col-12 col-sm-6 mt-2 px-1">
          <ReactSelect
            title=" انتخاب سفارش"
            itemsList={orders.dataOrder}
            inputValue={formValues.order}
            onChangeFunc={(e) => {
              handelChangeSelect(e, "order");
            }}
            onInputChangeFunc={(e) => {
              orderDebounce(e);
            }}
            placeholder="..."
            inputSize="same-as-select"
          ></ReactSelect>
        </div>
        <div className="col-12 col-sm-6 mt-2 px-1">
          <ReactSelect
            title="نوع ورودی"
            itemsList={configItem.dataCheckInType}
            inputValue={formValues.checkInType}
            onChangeFunc={(e) => {
              handelChangeSelect(e, "checkInType");
            }}
            onInputChangeFunc={(e) => {
              orderDebounce(e);
            }}
            textErr={
              showValid && !formValues.checkInType
                ? "این فیلد باید پر باشد"
                : ""
            }
            placeholder="..."
            inputSize="same-as-select"
          ></ReactSelect>
        </div>
        <div className="col-12 mt-2 px-1">
          <CustomInput
            id="titleTour"
            label="توضیحات "
            inputSize="same-as-select"
            type="text"
            inputType="textarea"
            inputContainer=""
            inputValue={formValues.desc}
            textErr={""}
            onChangeFunc={(e) => {
              handelChangeInput(e.target.value, "desc");
            }}
          />
        </div>
        <div className="d-flex justify-content-end mt-3 w-100">
          <CustomButton
            size="medium "
            className=""
            onClick={addRecordApiHandler}
            color="success"
          >
            ثبت
          </CustomButton>{" "}
        </div>
      </Modal.Body>
    </Modal>
  );
}
